module.exports = __webpack_public_path__ + "static/yellow_label-7d7fa801e226b0c7de01046965435e79.png";